import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import authService from './api-authorization/AuthorizeService';
import { toast } from 'react-toastify';


const ReportPrepaidInvoicesSentData = (props: RouteComponentProps<{}>) => {
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [loading, setLoading] = React.useState(true);
    const [date, setDate] = React.useState("");

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunInvoicesSentToReckonReport&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                setLoading(false);
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const handleDateChange = (e: any) => {
        let errorList = errors;
        delete errorList["date"];
        setErrors(errorList);
        setDate(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!date) {
            formIsValid = false;
            errorList["date"] = "Date is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data

        if (validate()) {
            runRpt();
        }
    }

    const runRpt = async () => {
        var url = "/report/PrepaidInvoicesSentReport/" + date + "/-1/-1/-1/-1";
        window.open(url, '_blank');
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Prepaid Invoices Sent To Reckon</h1>
            </div>
            <div className="marginTop20">
                <span>Gets a list of all prepaid customer invoices sent to Reckon for the selected date.</span>
            </div>
            <div>
                <label className="input-group" htmlFor="date">
                    <span className="label">Date</span>
                    <input type='date' id="date" name="date" className='input' value={date} onChange={(e) => handleDateChange(e)}></input>
                </label>
                <span className={errors["date"] ? "label errors marginLeftLabel" : "hidden"}>{errors["date"]}</span>
            </div>
            <button className="defaultbutton marginLeftLabel" type='button' onClick={runReport}>Run Report</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportPrepaidInvoicesSentData;